module.exports = __webpack_public_path__ + "img/industries_news_1.c7649537.png";